import * as ErrorService from 'shared-services/error-service';

import { debugLogEnabled } from 'services/env-service';
import { log as apiLog } from 'api/global-api';

let userProps = {};

export const logError = (type = 'general', error, extraData) => {
    console.error(error);

    if (type === 'saga') {
        return;
    }

    ErrorService.logError({
        type,
        error,
        customData: extraData
    });
}

export const debugLog = (...args) => {
    if (!debugLogEnabled()) {
        return;
    }

    console.log(...args);
}

export const remoteLog = (...args) => {
    debugLog(...args);

    apiLog({
        log: args[0],
        meta: {
            userId: userProps?.id,
            email: userProps?.email
        }
    });
};

export const setUserProps = props => {
    userProps = props;
    ErrorService.setUserProps(props);
};
